<button mat-flat-button color="primary" (click)="openDialog()">Crear tag</button>